import React, { useEffect, useState } from "react";
import { Select, Modal, Button, Input, Form, message, Popconfirm } from "antd";
import PropTypes from "prop-types";
import parse from "html-react-parser";

const { TextArea } = Input;

export const EmailConfig = ({ 
	open, 
	setOpen, 
	invoice, 
	exchangeRate, 
	clients, 
	company, 
	isRecurrency = false, 
	emailData = null, 
	onSaveData = null,
	isCreate = false
}) => {
	const [emailText, setEmailText] = useState("");
	const [previewVisible, setPreviewVisible] = useState(false);
	const [form] = Form.useForm();

	const handleTextChange = (e) => {
		setEmailText(e.target.value);
	};

	const showPreview = () => {
		setPreviewVisible(true);
	};

	const handleCancel = () => {
		setPreviewVisible(false);
	};
	const handleGeneralCancel = () => {
		setOpen(false);
	};

	const handleEmit = () => {
		form.validateFields()
			.then(values => {
				const newInvoice = {
					...invoice,
					email: {
						contacts: values.contacts,
						message: emailText,
					},
				};
				onSaveData && onSaveData(newInvoice);
				setOpen(false);
			})
			.catch(errorInfo => {
				console.error("Validation failed:", errorInfo);
				message.error("Debe rellenar toda la información");
			});
	};
	

	const handleEmitWithoutEmail = () => {
		const newInvoice = { ...invoice, email: {} };
		onSaveData && onSaveData(newInvoice);
		setOpen(false);
	};

	const agregarMensajePredeterminado = () => {
	
		const mensajePredeterminado = `<p>Estimado <b>${isRecurrency? invoice.receptor.name : invoice.client.name}</b>,</p>
<p>Adjunto encontrarán su factura. Agradecemos que realice el pago y nos envíe el comprobante respondiendo a este correo.</p>
<p>Si tiene alguna consulta o necesita más información, no dude en contactarnos. Estamos a su disposición para cualquier aclaración.</p>
<p>Atentamente,</p><p><b>${company.name}</b></p>
		`;
	
		setEmailText(mensajePredeterminado);
	};

	useEffect(() => {
		if(emailData){
			const { message : messageForEmail } = emailData;
			setEmailText(messageForEmail? messageForEmail: "");
			form.setFieldsValue(emailData);
		}
	}, []);

	return (
		<Modal
			open={open}
			centered
			width='80vw'
			title='Detalles de Correo'
			onCancel={handleGeneralCancel}
			footer={[
				<Button 
					key="emit" 
					type="primary" 
					size="large"
					onClick={handleEmit}>
						
					{(isRecurrency || isCreate)? "Guardar" : "Emitir y Enviar Correo Electrónico"}
				</Button>,
				<Popconfirm
					title="NO Enviar Correo Electrónico"
					description="Estás seguro que NO quieres enviar un correo electrónico?"
					okText="SI"
					cancelText="NO"
					onConfirm={handleEmitWithoutEmail}
					key={"0"}
				>
					<Button 
						key="emit-no-email" 
						size="large"
					>
						{(isRecurrency || isCreate)? "Guardar y Omitir Correo Electrónico" : "Emitir y NO Enviar Correo Electrónico"}
					</Button>
				</Popconfirm>
			]}
		>
			<h3>Contactos</h3>
			<Form form={form}>
				<Form.Item
					name='contacts'
					rules={[{ required: true, message: "Por favor ingrese un contacto para enviar el correo" }]}
				>
					<Select
						title="Contactos"
						mode="tags"
						style={{ width: "100%" }}
						options={[
							...(clients &&invoice.client && clients.find(client => client.id == invoice.client.id) ? clients.find(client => client.id == invoice.client.id).contacts.map(contact => ({ label: `${contact.name} (${contact.email})`, value: contact.email })) : []),
							...(clients &&invoice.receptor && clients.find(client => client.id == invoice.receptor.id) ? clients.find(client => client.id == invoice.receptor.id).contacts.map(contact => ({ label: `${contact.name} (${contact.email})`, value: contact.email })) : []),
							...(company.contacts ? company.contacts.map(contact => ({ label: `${contact.name} (${contact.email})`, value: contact.email })) : [])
						]}
					/>
				</Form.Item>

				<h3>Mensaje</h3>
				<Form.Item
					name='message'
				>
					<TextArea
						rows={15}
						value={emailText}
						onChange={handleTextChange}
						placeholder="Escribe tu correo aquí..."
						defaultValue={invoice.currency === "USD"? `El tipo de cambio en la fecha de emisión de esta factura es ${exchangeRate}` : ""}
					/>
					<Button type="primary" style={{marginTop:10}} onClick={agregarMensajePredeterminado}>
						Insertar Mensaje Predeterminado
					</Button>
					<Button onClick={showPreview} style={{ marginLeft: "10px" }}>
						Vista Previa
					</Button>
				</Form.Item>
			</Form>
			<Modal
				width='80vw'
				title="Vista Previa del Correo"
				visible={previewVisible}
				onCancel={handleCancel}
				footer={null}
			>
				<div
					style={{
						whiteSpace: "pre-wrap",
						wordWrap: "break-word"
					}}
				>
					{parse(emailText)}
				</div>
			</Modal>
		</Modal>
	);
};

EmailConfig.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	invoice: PropTypes.object.isRequired,
	setInvoice: PropTypes.func,
	exchangeRate: PropTypes.number.isRequired,
	clients: PropTypes.array,
	company: PropTypes.object.isRequired,
	emailData: PropTypes.object,
	onSaveData: PropTypes.func,
	isRecurrency: PropTypes.bool,
	isCreate: PropTypes.bool,
};

